import { useEffect, useState } from "react";
import SwiperCore, { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
SwiperCore.use([Navigation, Pagination]);
import * as C from "./Customizing.styles";
import { connect } from "react-redux";
import { useBannerStore } from "@store/useBannerStore";

const CustomizingSlider = ({ banners }) => {
  const { customLg, customSm } = useBannerStore((s) => s);

  return (
    <>
      {customLg && customSm && customLg.length > 0 && customSm.length > 0 && (
        <C.CustomizingSliderSection>
          {/* 좌측 빅 배너 */}
          <C.LeftBigBanner>
            <Swiper
              slidesPerView={1}
              autoplay={true}
              loop={customLg && customLg.length > 1}
              navigation={{
                prevEl: ".custom_prev_leftBig",
                nextEl: ".custom_next_leftBig",
              }}
              className="custom-class"
              initialSlide={1}
            >
              {customLg &&
                customLg.map((el, i) => (
                  <SwiperSlide key={i}>
                    {el?.P_FileUrl ? (
                      <C.LeftBigSlide>
                        <a
                          href={el.link_url || "#"}
                          target={el.new_win === "Y" ? "_blank" : "_self"}
                          className="P"
                        >
                          <img
                            src={el.P_FileUrl}
                            alt={el.img_alt || "프로모션 이미지"}
                          />
                        </a>
                      </C.LeftBigSlide>
                    ) : null}
                  </SwiperSlide>
                ))}
            </Swiper>
            {customLg && customLg.length > 1 && (
              <div className="slider-arrow">
                <span className="slider-btn slider-prev slick-arrow custom_prev_leftBig">
                  <i className="fi-rs-angle-left"></i>
                </span>
                <span className="slider-btn slider-next slick-arrow custom_next_leftBig">
                  <i className="fi-rs-angle-right"></i>
                </span>
              </div>
            )}
          </C.LeftBigBanner>
          {/* 우측 스몰 배너 */}
          <C.RightSmallBanner>
            <Swiper
              slidesPerView={1}
              autoplay={true}
              loop={customSm && customSm.length > 1}
              navigation={{
                prevEl: ".custom_prev_rightSmall",
                nextEl: ".custom_next_rightSmall",
              }}
              className="custom-class"
              initialSlide={1}
            >
              {customSm &&
                customSm.map((el, i) => (
                  <SwiperSlide key={i}>
                    {el?.P_FileUrl ? (
                      <C.LeftBigSlide>
                        <a
                          href={el.link_url || "#"}
                          target={el.new_win === "Y" ? "_blank" : "_self"}
                          className="P"
                        >
                          <img
                            src={el.P_FileUrl}
                            alt={el.img_alt || "프로모션 이미지"}
                          />
                        </a>
                      </C.LeftBigSlide>
                    ) : null}
                  </SwiperSlide>
                ))}
            </Swiper>
            {customSm && customSm.length > 1 && (
              <div className="slider-arrow">
                <span className="slider-btn slider-prev slick-arrow custom_prev_rightSmall">
                  <i className="fi-rs-angle-left"></i>
                </span>
                <span className="slider-btn slider-next slick-arrow custom_next_rightSmall">
                  <i className="fi-rs-angle-right"></i>
                </span>
              </div>
            )}
          </C.RightSmallBanner>
          {/* 모바일 배너 */}
          <C.MobileBanner>
            <Swiper
              slidesPerView={1}
              autoplay={true}
              loop={true}
              className="custom-class"
              initialSlide={0}
            >
              {[...customLg, ...customSm].map((el, i) => (
                <SwiperSlide key={i}>
                  <C.LeftBigSlide>
                    <a
                      href={el.link_url}
                      target={el.new_win === "Y" ? "_blank" : "_self"}
                      className="M"
                      rel={
                        el.new_win === "Y" ? "noopener noreferrer" : undefined
                      }
                    >
                      <img
                        src={el.M_FileUrl}
                        alt={el.img_alt || "모바일 배너"}
                      />
                    </a>
                  </C.LeftBigSlide>
                </SwiperSlide>
              ))}
            </Swiper>
          </C.MobileBanner>
        </C.CustomizingSliderSection>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  banners: state.banners,
});

export default connect(mapStateToProps, null)(CustomizingSlider);
